import { render } from "./BlogsSlider.vue?vue&type=template&id=3990fc0e&scoped=true"
import script from "./BlogsSlider.vue?vue&type=script&lang=js"
export * from "./BlogsSlider.vue?vue&type=script&lang=js"

import "./BlogsSlider.vue?vue&type=style&index=0&id=3990fc0e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3990fc0e"]])

export default __exports__